import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function (state = initialState.patients, { type, payload }) {
    switch (type) {
        case types.PATIENTS_REQUEST:
            return {
                ...initialState.patients,
                isLoading: true,
                isStatus: 'request',
                request: payload,
                successResponse: {},
                errorResponse: {}
            };
        case types.PATIENTS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isStatus: 'success',
                successResponse: payload,
                request: {}
            };
        case types.PATIENTS_FAILURE:
            return {
                ...state,
                isLoading: false,
                isStatus: 'error',
                successResponse: {},
                errorResponse: payload,
                request: {}
            };
        default:
            return state;
    }
}